import React, { useEffect, useState } from "react";
import { Cookies } from "react-cookie";
import { toast } from "react-toastify";
import PieChart from "../../../src/components/ui/Charts/PieChart";
import { Select } from "@chakra-ui/react";

function ProspectChart() {
  const cookies = new Cookies();
  const baseURL = process.env.REACT_APP_BACKEND_URL;

  const [individuals, setIndividuals] = useState([]);
  const [corporates, setCorporates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedGraph, setSelectedGraph] = useState("both");

  // ---------- FETCH INDIVIDUALS ----------
  const fetchAllIndividuals = async () => {
    const response = await fetch(`${baseURL}people/all-persons`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${cookies.get("access_token")}`,
      },
    });

    const result = await response.json();
    if (!result.success) throw new Error(result.message);

    setIndividuals(result.people);
  };

  // ---------- FETCH CORPORATES ----------
  const fetchAllCorporates = async () => {
    const response = await fetch(`${baseURL}company/all-companies`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${cookies.get("access_token")}`,
      },
    });

    const result = await response.json();
    if (!result.success) throw new Error(result.message);

    setCorporates(result.companies);
  };

  // ---------- FETCH BOTH ----------
  useEffect(() => {
    const fetchAll = async () => {
      try {
        setLoading(true);
        await Promise.all([fetchAllIndividuals(), fetchAllCorporates()]);
      } catch (err) {
        toast.error(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  // ---------- CHART DATA ----------
  const getChartData = () => {
    switch (selectedGraph) {
      case "individual":
        return {
          labels: ["Individual"],
          data: [individuals.length],
          ChartColors: ["#21CAC1"],
        };

      case "corporate":
        return {
          labels: ["Corporates"],
          data: [corporates.length],
          ChartColors: ["#F57D6A"],
        };

      default: // both
        return {
          labels: ["Individual", "Corporates"],
          data: [individuals.length, corporates.length],
          ChartColors: ["#21CAC1", "#F57D6A"],
        };
    }
  };

  const chartData = getChartData();

  return (
    <div className="w-full mx-auto mt-3">
      <h1 className="text-lg md:text-xl font-semibold">Prospects Summary</h1>

      {/* Dropdown */}
      <div className="mt-2">
        <Select
          value={selectedGraph}
          onChange={(e) => setSelectedGraph(e.target.value)}
        >
          <option value="both">Both</option>
          <option value="individual">Individual</option>
          <option value="corporate">Corporates</option>
        </Select>
      </div>

      {!loading && (
        <div className="mx-auto  w-full">
          <PieChart 
            labels={chartData.labels}
            data={chartData.data}
            ChartColors={chartData.ChartColors}
          />
        </div>
      )}
    </div>
  );
}

export default ProspectChart;
